import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import { loadProducts, loadProductsFailure, loadProductsSuccess, toggleProductsLoading } from './products.actions';

@Injectable()
export class ProductsEffects {
  private readonly actions$ = inject(Actions);
  private readonly referenceService = inject(ReferenceService);

  loadProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProducts),
      switchMap(() => {
        return this.referenceService.referenceSasSecLookupGetProductsGet().pipe(
          map((response) => {
            return loadProductsSuccess({ products: response.result || [] });
          }),
          catchError((error) => {
            return of(loadProductsFailure({ error }));
          }),
        );
      }),
    ),
  );

  toggleLoading$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProducts),
      map(() => toggleProductsLoading({ loading: true })),
    ),
  );

  stopLoading$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProductsSuccess, loadProductsFailure),
      map(() => toggleProductsLoading({ loading: false })),
    ),
  );
}
